import React, { useCallback } from "react";
import webui from "@tinqin/tinqin-web-ui";
import { IComponentProps, SirenEntityBuilder } from "../../common/utils/commonTypes";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { getAddressFromActions } from "../../common/actions/page/PageAddress";

const extractDataProps = (data: IComponentProps["data"] = {}) => {
    const siren: SirenEntityBuilder = EntityBuilder.of(data);

    const title: string = siren.getChild("title").getValue();
    const badge: string = siren.getChild("badge").getValue();
    const selected: boolean = siren.getProperty("selected");

    return {
        title,
        badge,
        selected
    };
};

export const ArticleFolderTab: React.FC<IComponentProps> = props => {
    const {
        extraClasses
    }: {
        extraClasses: string;
    } = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["extraClasses"],
        propsDefaults: {
            extraClasses: ""
        }
    });

    const onClick = useCallback(
        (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
            e.preventDefault();
            webui.getUtils().dispatchSirenActions(props, ["default", "click"]);
        },
        [props]
    );

    if (!props.data) {
        return webui.getUtils().getEmptyContent();
    }

    const { title, badge, selected } = extractDataProps(props.data);

    return (
        <div className={`un-article-folder-tab ${extraClasses} ${selected ? "tq-current" : ""}`} onClick={onClick}>
            <a href={getAddressFromActions(props.data.actions)}>
                <div className="tq-flex-container">
                    {title && <p>{title}</p>}
                    {badge && (
                        <div className="un-badge-box">
                            <div className="tq-badge">{badge}</div>
                        </div>
                    )}
                </div>
            </a>
        </div>
    );
};

export default webui.connectComponent()(ArticleFolderTab);
